<template>
  <div class="horizontal-filter-menu">
    <section class="p-0">
      <div class="stay-title mb-4">{{ category }}</div>
      <div class="title menu-item">キーワード</div>
      <div class="menu-item keyword-box">
        <input
          v-model="filterForm.keyword"
          placeholder="施設名など"
          :maxLength="100"
          class="keyword-box__input"
          :class="{ 'is-error': error.keywordError }"
        />
      </div>
    </section>
    <!-- <section class="p-0">
      <div class="title menu-item">カテゴリ</div>
      <div class="menu-item mb-2 pt-0 px-0">
        <a-radio-group
          v-model="filterForm.category"
          class="category-stay"
          @change="switchCategory"
        >
          <a-radio-button
            v-for="(category, index) in categories"
            :key="index"
            :value="category.value"
          >
            <span class="category-label">
              {{ category.title }}
              <img
                v-show="filterForm.category === category.value"
                src="@/assets/icons/icon-check.svg"
                alt=""
              />
            </span>
          </a-radio-button>
        </a-radio-group> -->
        <!-- DP検索用に項目追加 start -->
        <!-- <div class="l-side-tour">
          <div class="l-side-tour__wrap">
            <div class="l-side-tour__lists">
              <ul>
                <li
                  class="l-side-tour__list accordion"
                  v-for="(item, i) in categoryList"
                  :key="i"
                >
                  <ul v-if="item.level2">
                    <li
                      v-show="item.flag"
                      v-for="(item2, i) in item.level2"
                      :key="i"
                      class="l-side-tour__list"
                    >
                      <span
                        v-if="item2.catClassCd !== '207' && item2.catClassCd !== '201' &&  item2.catClassCd !== '204'"
                        class="l-side-tour__list__item level"
                        role="link">
                        <a :href="redirectUrl(item2.catClassCd,null)">
                          <div class="level-url">
                            {{ item2.name }}
                          </div>
                        </a>
                        <button @click="isOpen(item2.catClassCd)" class="accordion__button">
                            <svg
                              class="accordion__angle"
                              :class="{ 'rotate-180': !item2.flag, 'rotate-0': item2.flag }"
                              fill="none"
                              stroke="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 16 10"
                            >
                              <path
                                d="M15 1.2l-7 7-7-7"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                        </button>
                      </span>
                      <template>
                        <ul v-if="item2.level3">
                          <li
                            v-for="(item3, i) in item2.level3"
                            :key="i"
                            class="l-side-tour__list"
                          >
                            <span
                              v-if="
                                (item2.catClassCd === '207' && item3.catClassCd === '301')
                                || (item2.catClassCd === '201' && item3.catClassCd === '311')
                                || (item2.catClassCd === '204' && item3.catClassCd === '301')
                              "
                              class="l-side-tour__list__item level"
                              role="link"
                            >
                              <a :href="redirectUrl(item2.catClassCd,item3.catClassCd)">
                                <div class="level-url">
                                  {{ item3.name }}
                                </div>
                              </a>
                            </span>
                            <span
                            v-if="
                              item3.flag
                              && (item2.catClassCd !== '207' && item2.catClassCd !== '201' && item2.catClassCd !== '204')"
                              class="l-side-tour__list__item level2"
                              role="link"
                            >
                              <a :href="redirectUrl(item2.catClassCd,item3.catClassCd)">
                                <div class="level2-url">
                                  {{ item3.name }}
                                </div>
                              </a>
                              </span>
                          </li>
                        </ul>
                      </template>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div> -->
        <!-- DP検索用に項目追加 end -->
      <!-- </div>
    </section> -->

    <!--area-->
    <section class="p-0">
      <div class="title menu-item">エリア</div>
      <div class="menu-item menu-item-select">
        <a-select
          v-model="filterForm.areaMidClassCd"
          class="w-full"
          placeholder="都道府県"
          allowClear
          size="large"
          @change="searchNative"
        >
          <a-select-option
            v-for="middle in middleAreaList"
            :key="`middle-${middle}`"
            :value="middle.areaMidClassCd"
          >
            {{ middle.areaMidClassNm }}
          </a-select-option>
        </a-select>

        <a-select
          v-model="filterForm.areaSmlClassCd"
          class="w-full mt-2"
          placeholder="市区町村"
          allowClear
          size="large"
          :disabled="!filterForm.areaMidClassCd"
          @change="searchNative"
        >
          <a-select-option
            v-for="small in smallAreaList"
            :key="`small-${small}`"
            :value="small.areaSmlClassCd"
          >
            {{ small.areaSmlClassNm }}
          </a-select-option>
        </a-select>

        <a-select
          v-model="filterForm.areaDtlClassCd"
          class="w-full mt-2"
          placeholder="エリア"
          allowClear
          size="large"
          @change="searchNative"
          :disabled="!filterForm.areaSmlClassCd || dtlAreaList.length === 0"
        >
          <a-select-option
            v-for="dtl in dtlAreaList"
            :key="`dtl-${dtl}`"
            :value="dtl.areaDtlClassCd"
          >
            {{ dtl.areaDtlClassNm }}
          </a-select-option>
        </a-select>
      </div>
    </section>

    <section v-if="isPublicStay" class="flex justify-center mb-8 mt-4 px-4">
      <a-button @click="search" class="w-full rounded btn-filter">この条件で絞り込む（{{ totalItems }}）</a-button>
    </section>

    <template v-if="!isPublicStay">
      <section class="p-0">
        <div class="title menu-item">期間</div>
        <div class="menu-item flex items-center mt-1">
          <a-date-picker
            v-model="filterForm.checkInDate"
            class="w-40 date-filter"
            type="date"
            placeholder="日付指定なし"
            format="YYYY/MM/DD（dd）"
            size = "large"
            :disabledDate="checkDisabledDate"
          >
            <template #suffixIcon>
              <Icon name="datepicker"/>
            </template>
          </a-date-picker>
          <span class="text-base ml-2 whitespace-nowrap">から</span>
        </div>
        <div class="menu-item mb-1 pt-0">
          <Stepper
            v-model="filterForm.stayNights"
            size="large"
            unit="泊"
            min="1"
            max="6"
            :readonly="true"
            @change="searchNative"
          />
        </div>
      </section>

      <section class="p-0">
        <div class="title menu-item">部屋数</div>
        <div class="menu-item my-1">
          <Stepper
            v-model="filterForm.roomCnt"
            size="large"
            unit=""
            min="1"
            max="10"
            :readonly="true"
            @change="searchNative"
          />
        </div>
      </section>

      <section class="p-0">
        <div class="title menu-item">1部屋あたりご利用人数</div>
        <div class="menu-item flex items-center gap-x-4 mt-2">
          <div class="text-title">大人</div>
          <Stepper
            size="large"
            unit="人"
            min="1"
            max="10"
            v-model="filterForm.adultHeadCnt"
            @change="searchNative"
          />
        </div>
        <div class="menu-item flex items-center gap-x-4 mb-2">
          <div class="text-title">子ども</div>
          <ChildrenPlan
            class="ml-7"
            @changeChildrenQuantity="onChangeChildrenQuantity"
            :filterForm="filterForm"
          />
        </div>
      </section>

      <section class="p-0 mb-4">
        <Collapse
          v-model="collapseActiveKey"
          :keyCollapse="15"
          title="予算"
          :getHeightFlag="getHeightFlag"
        >
          <div class="menu-item flex items-center gap-x-4 whitespace-nowrap mt-2">
            下限
            <a-select
              class="w-full"
              size="large"
              placeholder="エリアを選択"
              v-model="filterForm.feeLower"
              @change="searchNative"
            >
              <a-select-option value="0">下限なし</a-select-option>
              <a-select-option
                v-for="(item, i) in filterFormOptions.feeLower"
                :key="`area-${i}`"
                :value="item.value"
              >
                {{ item.displayName }}
              </a-select-option>
            </a-select>
          </div>
          <div class="menu-item flex items-center gap-x-4 whitespace-nowrap pt-0">
            上限
            <a-select
              size="large"
              class="w-full"
              placeholder="エリアを選択"
              v-model="filterForm.feeUpper"
              @change="searchNative"
            >
              <a-select-option value="0">上限なし</a-select-option>
              <a-select-option
                v-for="(item, i) in filterFormOptions.feeUpper"
                :key="`area-${i}`"
                :value="item.value"
                :disabled="parseInt(item.value) < parseInt(filterForm.feeLower)"
              >
                {{ item.displayName }}
              </a-select-option>
            </a-select>
          </div>
          <!-- <span class="menu-item-tip">※1部屋あたり消費税込み</span> -->
        </Collapse>
      </section>

      <!--roomType-->
      <section class="p-0 mb-4">
        <Collapse
          v-model="collapseActiveKey"
          :keyCollapse="2"
          :isShowCollapseBtn="filterFormOptions.roomType.length > 4"
          title="部屋タイプ"
          :getHeightFlag="getHeightFlag"
        >
          <a-checkbox-group v-model="filterForm.roomType" @change="searchNative">
            <a-checkbox
              v-for="(item, index) in filterFormOptions.roomType"
              :value="item.value"
              :key="index"
            >
              {{ item.displayName }}
            </a-checkbox>
          </a-checkbox-group>
        </Collapse>
      </section>

      <!--mealCondition-->
      <section class="p-0 mb-4">
        <Collapse
          v-model="collapseActiveKey"
          :keyCollapse="3"
          :isShowCollapseBtn="filterFormOptions.mealCondition.length > 4"
          title="食事条件"
          :getHeightFlag="getHeightFlag"
        >
          <a-checkbox-group v-model="filterForm.mealCondition" @change="searchNative">
            <a-checkbox
              v-for="(item, index) in filterFormOptions.mealCondition"
              :value="item.value"
              :key="index"
            >
              {{ item.displayName }}
            </a-checkbox>
          </a-checkbox-group>
        </Collapse>
      </section>

      <!-- TODO: 追加のこだわり条件 モーダルへ変更するまでの一時対応 -->
      <Collapse
        id="collapseFrame"
        :keyCollapse="null"
        :isShowCollapseBtn="true"
        :collapseAll="true"
        :getHeightFlag="getHeightFlag"
      >
        <section class="flex justify-center mb-8 mt-4 p-4">
          <a-button @click="search" class="w-full rounded btn-filter">検索する</a-button>
        </section>

        <!--facility-->
        <section class="p-0 mb-4">
          <Collapse
            v-model="collapseActiveKey"
            :keyCollapse="1"
            :isShowCollapseBtn="filterFormOptions.facility.length > 4"
            title="施設タイプ"
            :getHeightFlag="getHeightFlag"
          >
            <a-checkbox-group v-model="filterForm.facility" @change="searchNative">
              <a-checkbox
                v-for="(item, index) in filterFormOptions.facility"
                :value="item.value"
                :key="index"
              >
                {{ item.displayName }}
              </a-checkbox>
            </a-checkbox-group>
          </Collapse>
        </section>

        <!-- CRM汎用独自対応 -->
        <!--roomCondition-->
        <!--
        <section class="p-0 mb-4">
          <Collapse
            v-model="collapseActiveKey"
            :keyCollapse="4"
            :isShowCollapseBtn="filterFormOptions.roomCondition.length > 4"
            title="部屋のこだわり"
            :getHeightFlag="getHeightFlag"
          >
            <a-checkbox-group v-model="filterForm.roomCondition" @change="searchNative">
              <a-checkbox
                v-for="(item, index) in filterFormOptions.roomCondition"
                :value="item.value"
                :key="index"
              >
                {{ item.displayName }}
              </a-checkbox>
            </a-checkbox-group>
          </Collapse>
        </section>
        -->

        <!-- CRM汎用独自対応 -->
        <!--serviceEquip-->
        <!--
        <section class="p-0 mb-4">
          <Collapse
            v-model="collapseActiveKey"
            :keyCollapse="5"
            :isShowCollapseBtn="filterFormOptions.serviceEquip.length > 4"
            title="設備・サービス"
            :getHeightFlag="getHeightFlag"
          >
            <a-checkbox-group v-model="filterForm.serviceEquip" @change="searchNative">
              <a-checkbox
                v-for="(item, index) in filterFormOptions.serviceEquip"
                :value="item.value"
                :key="index"
              >
                {{ item.displayName }}
              </a-checkbox>
            </a-checkbox-group>
          </Collapse>
        </section>
        -->

        <!--usageMethod-->
        <section class="p-0 mb-4">
          <Collapse
            v-model="collapseActiveKey"
            :keyCollapse="6"
            :isShowCollapseBtn="filterFormOptions.usageMethod.length > 4"
            title="利用方法"
            :getHeightFlag="getHeightFlag"
          >
            <a-checkbox-group v-model="filterForm.usageMethod" @change="searchNative">
              <a-checkbox
              v-for="(item, index) in getUsageMethod(filterFormOptions.usageMethod)"
              :value="item.value"
                :key="index"
              >
                {{ item.displayName }}
                <span v-if="item.value !== 'canUseCafeteriaPoint' && item.value !== 'canUseSubsidy'">
                </span>
              </a-checkbox>
            </a-checkbox-group>
          </Collapse>
        </section>

        <!--planByCompany-->
        <section class="p-0 mb-4">
          <Collapse
            v-model="collapseActiveKey"
            :keyCollapse="7"
            :isShowCollapseBtn="filterFormOptions.planByCompany.length > 4"
            title="提供会社"
            :getHeightFlag="getHeightFlag"
          >
            <a-checkbox-group v-model="filterForm.planByCompany" @change="searchNative">
              <a-checkbox
                v-for="(item, index) in filterFormOptions.planByCompany"
                :value="item.value"
                :key="index"
              >
                {{ item.displayName }}
              </a-checkbox>
            </a-checkbox-group>
          </Collapse>
        </section>
      </Collapse>
      <section class="flex justify-center p-4 pt-0">
        <a-button class="rounded w-full btn-filter" @click="search" size="large">
          この条件で絞り込む
        </a-button>
      </section>
    </template>
  </div>
</template>

<script>
import { Stepper, Collapse } from '@/components/primitive'
import uniqBy from 'lodash/uniqBy'
import moment from 'moment'
import ChildrenPlan from './components/ChildrenPlan'

export default {
  props: {
    filterForm: {
      default: () => ({})
    },
    filterFormOptions: {
      default: () => ({})
    },
    totalItems: {
      default: 0
    },
    error: {
      default: () => ({})
    },
    isShowSupplementaryCoupon: {
      type: Boolean,
      default: false
    }
  },
  name: 'HorizontalFilterMenu',

  components: {
    Stepper,
    ChildrenPlan,
    Collapse
  },

  data() {
    return {
      collapseActiveKey: [],
      nightCount: 1,
      roomCount: 1,
      areaInitList: [],
      smallAreaList: [],
      dtlAreaList: [],
      collapseHeight: 0,
      getHeightFlag: false,
      isShowCafeteriaPoint: false,
      lrgCategoryList: [],
      midCategoryList: [],
      smlCategoryList: [],
      categoryList: [],
    }
  },

  watch: {
    isPublicStay() {
      this.filterForm.areaLrgClassCd = undefined
      this.filterForm.areaMidClassCd = undefined
      this.filterForm.areaSmlClassCd = undefined
      this.filterForm.areaDtlClassCd = undefined
    },
    'filterForm.feeLower'(val) {
      if (
        Number(val) > Number(this.filterForm.feeUpper) &&
        this.filterForm.feeUpper !== '0'
      )
        this.filterForm.feeUpper = val
    },
    'filterForm.areaMidClassCd'(val) {
      this.setAreaLrgClassCd(val)
      this.filterForm.areaSmlClassCd = undefined
      this.filterForm.areaDtlClassCd = undefined
      this.smallAreaList = []
      if (val) {
        this.getSmlCodesArea(val)
      }
    },
    'filterForm.areaSmlClassCd'(val) {
      this.filterForm.areaDtlClassCd = undefined
      this.dtlAreaList = []
      if (val) {
        this.getDtlCodesArea(val)
      }
    },
    'filterForm.checkInDate': {
      handler(newVal, oldVal) {
        if (
          newVal &&
          oldVal &&
          moment(newVal).format('YYYY/MM/DD') === moment(oldVal).format('YYYY/MM/DD')
        ) {
          return
        }
        this.searchNative()
      }
    },
    $route() {
      this.setDocumentTitle();
    }
  },
  async created() {
    await this.initAreaData()
    if (this.filterForm?.areaMidClassCd) {
      this.getSmlCodesArea(this.filterForm.areaMidClassCd)
    }
    if (this.filterForm?.areaSmlClassCd) {
      this.getDtlCodesArea(this.filterForm.areaSmlClassCd)
    }
    // DP検索対応 start
    // DP検索用のカテゴリセット
    this.lrgCategoryList = [
      {
        "flag": false,
        "catLrgClassCd": "",
        "level1": "トラベル",
        "level2": [],
        "catClassCd": "101",
        "catMidClassCd": ""
      }
     ];

    this.midCategoryList = [
      // {
      //   "flag": false,"catLrgClassCd": "101","catClassCd": "205","name": "パッケージツアー・旅行代理店",
      //   "level3": [
      //     {"name": "パッケージツアー","catClassCd": "301","catMidClassCd": "205","catLrgClassCd": "101"},
      //     {"name": "旅行代理店","catClassCd": "302","catMidClassCd": "205","catLrgClassCd": "101"}
      //   ],
      // },
      {
        "flag": false,"catLrgClassCd": "101","catClassCd": "206","name": "航空券・交通",
        "level3": [
          {"catClassCd": "301","catMidClassCd": "206","catLrgClassCd": "101","name": "航空券"},
          {"catClassCd": "302","catMidClassCd": "206","catLrgClassCd": "101","name": "フェリー・クルーズ"},
          {"catClassCd": "303","catMidClassCd": "206","catLrgClassCd": "101","name": "バス･タクシー"},
          {"catClassCd": "304","catMidClassCd": "206","catLrgClassCd": "101","name": "その他航空券・交通"}
        ],
      },
      {
        "flag": true,"catLrgClassCd": "101","catClassCd": "207","name": "その他旅行関連",
        "level3": [
          {"catClassCd": "301","catMidClassCd": "207","catLrgClassCd": "101","name": "その他旅行関連"}
        ],
      },
      {
        "flag": true,"catLrgClassCd": "101","catClassCd": "201","name": "国内の宿",
        "level3": [
          {"catClassCd": "311","catMidClassCd": "201","catLrgClassCd": "101","name": "予約サイト"}
      ]
      },
      {
        "flag": true,"catLrgClassCd": "101","catClassCd": "204","name": "海外旅行",
        "level3": [
          {"catClassCd": "301","catMidClassCd": "204","catLrgClassCd": "101","name": "海外旅行"}
        ],
      }
    ];

    // アコーディオンで最初は小カテゴリは非表示にするため、flagをfalseに設定
    this.smlCategoryList = [
      // {"flag": false,"catClassCd": "301","catMidClassCd": "205","catLrgClassCd": "101","name": "パッケージツアー"},
      // {"flag": false,"catClassCd": "302","catMidClassCd": "205","catLrgClassCd": "101","name": "旅行代理店"},
      {"flag": false,"catClassCd": "301","catMidClassCd": "206","catLrgClassCd": "101","name": "航空券"},
      {"flag": false,"catClassCd": "302","catMidClassCd": "206","catLrgClassCd": "101","name": "フェリー・クルーズ"},
      {"flag": false,"catClassCd": "303","catMidClassCd": "206","catLrgClassCd": "101","name": "バス･タクシー"},
      {"flag": false,"catClassCd": "304","catMidClassCd": "206","catLrgClassCd": "101","name": "その他航空券・交通"},
      {"flag": false,"catClassCd": "301","catMidClassCd": "207","catLrgClassCd": "101","name": "その他旅行関連"},
      {"flag": false,"catClassCd": "311","catMidClassCd": "201","catLrgClassCd": "101","name": "国内宿泊予約サイト"},
      {"flag": false,"catClassCd": "301","catMidClassCd": "204","catLrgClassCd": "101","name": "海外宿泊予約サイト"}
    ];
    this.catListGen;
     // DP検索対応 end
  },
  computed: {
    middleAreaList() {
      return uniqBy(this.areaInitList, 'areaMidClassCd')
    },
    isPublicStay() {
      return this.filterForm.category === 'publicStay'
    },
    category() {
      return this.isPublicStay ? '公共の宿' : '国内宿泊'
    },
    // DP検索で使用する処理追加 start
    catListGen() {
      this.categoryList = this.lrgCategoryList;
      const selected = '101';
      if (selected > 0) {
        let middles = this.midCategoryList.filter(
          (item) => item.catLrgClassCd === selected.toString()
        );
        middles.forEach((mid) => {
          let smalls = this.smlCategoryList.filter(
            (item) =>
              item.catMidClassCd === mid.catClassCd.toString() &&
              item.catLrgClassCd === selected.toString()
          );
          mid.level3 = smalls;
        });
        const selectedItem = this.categoryList.find(
          (item) => item.catClassCd === selected.toString()
        );
        if (selectedItem) {
          selectedItem.level2 = middles;
        }
        return selectedItem ? (selectedItem.flag = true) : [];
      }
    },
    // DP検索で使用する処理追加 end
  },

  methods: {
    search() {
      this.$emit('search')
    },

    switchCategory() {
      this.$emit('switchCategory')
    },

    getSelected() {
      this.$emit('statusChangeSelected', true)
    },

    searchNative() {
      this.$emit('search-native')
    },
    checkDisabledDate(date) {
      const now = moment(new Date())
      return date.isBefore(now, 'date')
    },
    onChangeChildrenQuantity(childDetails) {
      const childData = [
        'exUpperGradesHeadCnt',
        'exLowerGradesHeadCnt',
        'youjiAHeadCnt',
        'youjiBHeadCnt',
        'youjiCHeadCnt',
        'youjiDHeadCnt'
      ]

      childData.forEach((key) => {
        this.filterForm[key] = childDetails[key]
      })
    },
    setAreaLrgClassCd(midCode) {
      if (!midCode) this.filterForm.areaLrgClassCd = undefined
      const mids = this.areaInitList.filter((item) => item.areaMidClassCd === midCode)
      if (mids?.length) this.filterForm.areaLrgClassCd = mids[0].areaLrgClassCd
    },
    async initAreaData() {
      const res = await this.$repositories('search').getLargeCodesArea()
      if (res) {
        this.areaInitList = res.data || []
      }
    },
    async getSmlCodesArea(midCode) {
      let res = await this.$repositories('search').getCodesArea({
        areaLrgClassCd: this.filterForm.areaLrgClassCd,
        areaMidClassCd: midCode
      })
      if (res) {
        this.smallAreaList =
          res?.data?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses || []
      }
    },
    async getDtlCodesArea(smallCode) {
      let res = await this.$repositories('search').getCodesArea({
        areaLrgClassCd: this.filterForm.areaLrgClassCd,
        areaMidClassCd: this.filterForm.areaMidClassCd,
        areaSmlClassCd: smallCode
      })
      if (res) {
        this.dtlAreaList =
          res?.data?.areaLrgClasses?.[0]?.areaMidClasses?.[0]?.areaSmlClasses?.[0]
            ?.areaDtlClasses || []
      }
    },
    getMaxHeight() {
      // アコーディオンが全開の時のheightを取得
      const collapseHeight = document.getElementById('collapseFrame').scrollHeight
      this.collapseHeight = collapseHeight
      // 取得後<Collapse>にmax-heightを付与
      this.getHeightFlag = true
    },
    getUsageMethod(optionList) {
      let usageMethod = _.cloneDeep(optionList)

      if(!this.isShowCafeteriaPoint){
        usageMethod = usageMethod.filter(
          function( item ) { return item.value !== "canUseCafeteriaPoint"; });
      }
      if(!this.isShowSupplementaryCoupon){
        usageMethod = usageMethod.filter(
          function( item ) { return item.value !== "canUseSubsidy"; });
      }
      return usageMethod
    },
    async checkAvailableCafeAndSubsidy() {
      const cafe = await this.$repositories('cafe').checkCafeAvailable();
      const avaialbleCafe = cafe.data;

      if (avaialbleCafe && avaialbleCafe === 'OK') {
        this.isShowCafeteriaPoint = true;
      }
    },
    setDocumentTitle() {
      let areaName = this.getAreaName();
      let keywordName = this.$route.query.keyword;

      if ( areaName !== '') {
          document.title = `「${areaName}」の「ホテル/旅館」一覧｜割引・特別優待ならベネフィットステーション`;
        } else {
          if (keywordName) {
            document.title = `「${keywordName}」の「ホテル/旅館」一覧｜割引・特別優待ならベネフィットステーション`;
          } else {
            this.$meta.setDocumentTitle("検索結果");
          }
        }
        this.$emit('getDocTitle', document.title);
    },
    getAreaName() {
      let dtlAreaName = this.$route.query.areaDtlClassCd ? this.dtlAreaList.find(
        (item) => item.areaDtlClassCd === this.$route.query.areaDtlClassCd
        ).areaDtlClassNm : '';
      let smlAreaName = this.$route.query.areaSmlClassCd ? this.smallAreaList.find(
        (item) => item.areaSmlClassCd === this.$route.query.areaSmlClassCd
        ).areaSmlClassNm : '';
      let midAreaName = this.$route.query.areaMidClassCd ? this.middleAreaList.find(
        (item) => item.areaMidClassCd === this.$route.query.areaMidClassCd
        ).areaMidClassNm : '';

      if (dtlAreaName !== '') {
        return dtlAreaName;
      } else if (smlAreaName !== '') {
        return smlAreaName;
      } else if (midAreaName !== '') {
        return midAreaName;
      } else {
        return '';
      }
    },
    // DP検索カテゴリに関するURL生成
    redirectUrl(midCategory,smlCategory) {
      return this.updateQueryRouter(midCategory,smlCategory)
    },
    updateQueryRouter(midCategory,smlCategory) {
      const query = {}

      // 中カテゴリ「国内宿泊予約サイト」「海外宿泊予約サイト」はtype=4に設定
      const keyword = this.$route.query["keyword"] || '';
      if (keyword) {
        query.keyword = keyword;
      }

      if(midCategory === "201" || midCategory === "204") {
        query.type = "4";
      } else {
        // 中カテゴリ「パッケージツアー・旅行代理店」「航空券・交通」「その他旅行関連」はtype=3
        query.type = "3";
      }
      query.catLrgClassCd = "101";
      query.catMidClassCd = midCategory;
      if(smlCategory) {
        query.catSmlClassCd = smlCategory
      }
      const params = new URLSearchParams(query);
      // CRM汎用独自対応
      const url = process.env.VUE_APP_LIFE_DOMAIN + '/menus/tour?' + params;
      return url;
    },
    // アコーディオン処理
    isOpen(catClassCd) {
      let middles = this.midCategoryList;
      let smalls = this.smlCategoryList;
      middles.forEach((mid) => {
        // 中カテ：パッケージツアー・旅行代理店、航空券・交通の小カテ表示制御
        if (mid.catClassCd === catClassCd) {
          if (mid.flag) {
            mid.flag = false;
          } else {
            mid.flag = true;
          }
        }
      })
      smalls.forEach((sml) => {
        // 中カテ：パッケージツアー・旅行代理店、航空券・交通の小カテ表示制御
        if (sml.catMidClassCd === catClassCd) {
          if (sml.flag) {
            sml.flag = false;
          } else {
            sml.flag = true;
          }
        }
      });
    },
  },
  async mounted() {
    // 公共の宿が選択された時はheightが取得できないため条件分岐する
    if (this.$route.query.category === 'stay') {
      this.getMaxHeight()
    }
    this.checkAvailableCafeAndSubsidy()
    await this.initAreaData()
    if (this.filterForm?.areaMidClassCd) {
      await this.getSmlCodesArea(this.filterForm.areaMidClassCd)
    }
    if (this.filterForm?.areaSmlClassCd) {
      await this.getDtlCodesArea(this.filterForm.areaSmlClassCd)
    }
    this.setDocumentTitle();
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
.input-number ::v-deep input {
  text-align: center;
}

.menu-item ::v-deep .a-checkbox .n-checkbox__label {
  white-space: normal;
  width: calc(100% - 16px);
  line-height: 21px;
  font-size: 14px;
}

::v-deep {
  .ant-divider {
    margin: 12px 0;
  }
  .ant-radio-inner {
    border-color: #63666a;
  }
  .b-stepper {
    @apply justify-start;
  }
  .stepper-input {
    height: 40px;
    width: 64px;
    font-size: 0.9375rem;
    max-width: 100%;
    padding: 0;
  }
  .ant-select {
    width: 100%;
    &-selection {
      border: 1px solid #CACCCF;
      border-top-width: 1.02px;
    }
    &-selection__placeholder {
      font-size: 15px;
    }
    &-selection-selected-value {
      font-size: 15px;
      line-height: 37.5px;
    }

    &-arrow-icon svg {
      @apply text-black;
    }
  }


  .ant-input {
    border: 1px solid #cacccf;
    text-align: center;
  }
  .ant-btn {
    background-color: #222222;
    border-radius: 8px;
    border: none;
    span {
      font-size: 14px;
      font-weight: 700;
      color: white;
    }
  }
  .ant-checkbox-inner {
    border: 2px solid #63666a;
  }

  .date-filter {
    input {
      @apply text-left;
    }
  }

  .b-stepper.large {
    .icon {
      @apply text-2xl;
    }
  }
}

::v-deep .ant-checkbox {
  &-group {
    display: flex;
    flex-direction: column;
  }
  &-wrapper {
    font-size: 0.9375rem;
    margin: 5px 12px;
    margin-right: 0px;
    padding: 0;
  }
}
::v-deep .anticon-close-circle {
  opacity: 1;
  height: 16px;
}

::v-deep .btn-filter.ant-btn {
  height: 38px;
  span {
    @apply text-xs;
  }
}

// DP検索用のデザイン
.level {
  .level-url {
    color: #0c0c0c;
    padding: 0.5rem 1rem;
  }
}
.level2 {
  .level2-url {
    color: #0c0c0c;
    padding-left: 2.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 1.5rem;
  }
}
.l-side-tour {
  font-size: 0.875rem;
  // @include mq() {
  //   width: auto;
  // }
  &__wrap {
    // padding: 0.5rem 1rem;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    background-color: #fff;
    border-radius: .5rem;
    // box-shadow: 0 1px .5rem rgba($color: $CoolBlack, $alpha: .08);
    overflow: hidden;
    // @include mq() {
    //   overflow: unset;
    // }
  }
  &__lists {
    position: relative;
    ul {
      &:not(:last-child) {
        margin-bottom: .625rem;
        padding-bottom: .625rem;
        // border-bottom: 1px solid $CoolGray4;
        // @include mq() {
        //   margin-bottom: 1.75rem;
        //   padding-bottom: 0;
        // }
      }
    }
  }
  &__list {
    &.accordion {
      position: relative;
      .accordion__button {
        padding-right: 16px;
        font-size: 0.75rem;
        border: none;
        background-color: #ffffff00;
        width: 0.5rem;
        height: 2rem;
        position: absolute;
        right: 0;
        top: 0.2rem;
        z-index: 2;
      }
      .accordion__angle {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        // right: 10px;
        width: 0.7rem;
        height: 0.7rem;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 200ms;
        &.rotate-0 {
          transform: rotate(0deg);
        }
        &.rotate-180 {
          transform: rotate(180deg)
        }
      }
    }

    &__item {
      position: relative;
      display: block;
      // color: $CoolBlack;
      color: #0c0c0c;
      // padding: 0.5rem 1.5rem;
      .c-icon {
        position: absolute;
        top: 50%;
        right: 13px;
        transform: translateY(-50%);
      }
      &--head {
        font-weight: 700;
      }
      &--checked {
        position: absolute;
        top: 50%;
        right: 13px;
        transform: translateY(-50%);
        // color: $CoolGray1;
      }
      &--checkedMid {
        position: absolute;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
        // color: $CoolGray1;
      }
      @include mq() {
        padding-top: .625rem;
        padding-bottom: .625rem;
      }
      // input:checked + .c-checkbox__box::before {
      //   // color: $Red;
      // }
      &.level {
        &.level-url {
          color: #0c0c0c;
          padding: 0.5rem 1.5rem;
        }
      }
      &.level2 {
        & .level2-url {
          color: #0c0c0c;
          padding-left: 2.5rem;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
          padding-right: 1.5rem;
        }
      }
      &.level3 {
        padding-left: 3.5rem;
      }
    }
    &__bottom {
      border-bottom: none;
  }
  a {
    // color: $CoolBlack;
    color: #0c0c0c;
    // .c-icon {
    //   width: 1.25em;
    //   height: 1.25rem;
    //   // g {
    //   //   // fill: $CoolGray;
    //   // }
    // }
    // &:hover {
    //   // color: $Red;
    //   text-decoration: none;
    //   .c-icon {
    //     g {
    //       // fill: $Red;
    //     }
    //   }
    // }
  }
  .l-side__submit {
    text-align: center;
    .l-side__submit__button {
      width: 120px;
      padding: 0.25rem 1rem;
      // background-color: $CoolBlack;
      border-radius: 8px;
      cursor: pointer;
      @include mq() {
        background-color: #1f2021;
        padding: 1rem;
        width: 200px;
        border-radius: 8px;
      }
      .l-side__submit__label {
        color: #fff;
        font-size: 0.9rem;
      }
    }
  }
  // .l-side__select {
  //   margin-bottom: 0.5rem;
  //   padding: 0 1.5rem;
  //   @include mq() {
  //     margin-top: 0.5rem;
  //   }
  //   &.c-select:after {
  //     right: 2rem;
  //   }
  //   .l-side__select__control {
  //     height: 2rem;
  //     font-size: 0.9rem;
  //   }
  // }
  }
}
</style>
